export default __webpack_public_path__ + "static/media/what_we_do1.97b9837e.png";